import BannerPublishForm from "./BannerPublishForm.container";

export default BannerPublishForm;
